import {
  SuccessResponse,
  updateRecurring,
  UpdateRecurringResponse,
} from '@back-office/http';
import { FlowReturn } from 'mobx-state-tree/dist/core/flow';
import { ResponseMessage, STATUS_CODE_NOT_AUTHORIZED } from '../../constants';
import { handleErrorVoidRefund, handleNotAuthorized, Self } from '../common';

function* updateRecurringRequest(
  self: Self,
  recurringId: string,
  recurringStatus: string,
  reason: string
): Generator<Promise<FlowReturn<SuccessResponse>>> {
  self.isLoading = true;
  try {
    const response = yield updateRecurring(
      recurringId,
      recurringStatus,
      reason
    );
    const { data, status } = (response as UpdateRecurringResponse).data;
    if (data?.updateRecurringRequestForSubMerchant) {
      return Promise.resolve({ data });
    }
    if (status.code === STATUS_CODE_NOT_AUTHORIZED) {
      handleNotAuthorized(self, response as SuccessResponse);
      return Promise.reject(status.code);
    }
    handleErrorVoidRefund(self);
    return Promise.reject(new Error(ResponseMessage.Error));
  } catch (e) {
    return Promise.resolve('Internal server error.');
  } finally {
    self.isLoading = false;
  }
}

export default updateRecurringRequest;
